import React, { useEffect, useState } from "react";
import { BottomBarDLSType, ButtonSizeDLS, ButtonTypeDLS, ColorTokens, SizeTypeTokens, TextAlignTokens, TypographyTypeDLS } from "@voltmoney/schema";
import { StyleSheet, View } from "react-native";
import { Typography } from "../typography/Typography";
import { Space } from "../space/Space";
import { Button } from "../button/Button";
const BottomBar = ({ id, label, labelColor, labelTypeDLS = TypographyTypeDLS.B2R, btnLabel, btnLoading = false, btnTypeDLS = ButtonTypeDLS.PRIMARY, typeDLS, action, isDarkMode, triggerAction, isPositionAbsolute = true, onPress, children = undefined, btnSizeDLS = ButtonSizeDLS.LARGE, isDisabled = false, }) => {
    const [_btnloading, setLoading] = useState(false);
    useEffect(() => {
        setLoading(btnLoading);
    }, [btnLoading]);
    const child = () => {
        switch (typeDLS) {
            case BottomBarDLSType.TYPE_A:
                return (React.createElement(View, { style: [
                        styles.bottomBarContainerShadow,
                        isPositionAbsolute && {
                            position: 'absolute',
                            bottom: 0
                        },
                        isDarkMode && { backgroundColor: '#0D141F' }
                    ] },
                    label && (React.createElement(React.Fragment, null,
                        React.createElement(Typography, { label: label, typeDLS: labelTypeDLS, color: labelColor ?
                                labelColor :
                                ColorTokens.Grey_Night, textAlign: TextAlignTokens.center }),
                        React.createElement(Space, { size: SizeTypeTokens.MD }))),
                    children && (React.createElement(React.Fragment, null,
                        children,
                        React.createElement(Space, { size: SizeTypeTokens.MD }))),
                    btnLabel &&
                        React.createElement(Button, { id: id, typeDLS: btnTypeDLS, label: btnLabel, sizeDLS: btnSizeDLS, isDisabled: isDisabled, onPress: () => {
                                onPress &&
                                    onPress();
                            }, loading: _btnloading, action: action, triggerAction: triggerAction })));
            case BottomBarDLSType.TYPE_B:
                return (React.createElement(View, { style: [
                        styles.bottomBarContainerShadow,
                        isPositionAbsolute && {
                            position: 'absolute',
                            bottom: 0
                        },
                        isDarkMode && { backgroundColor: '#0D141F' }
                    ] },
                    btnLabel &&
                        React.createElement(Button, { id: id, typeDLS: btnTypeDLS, label: btnLabel, sizeDLS: btnSizeDLS, isDisabled: isDisabled, onPress: () => {
                                onPress &&
                                    onPress();
                            }, loading: _btnloading, action: action, triggerAction: triggerAction }),
                    label && (React.createElement(React.Fragment, null,
                        React.createElement(Space, { size: SizeTypeTokens.MD }),
                        React.createElement(Typography, { label: label, typeDLS: labelTypeDLS, color: labelColor ?
                                labelColor :
                                ColorTokens.Grey_Night, textAlign: TextAlignTokens.center }))),
                    children && (React.createElement(React.Fragment, null,
                        React.createElement(Space, { size: SizeTypeTokens.MD }),
                        children))));
            case BottomBarDLSType.TYPE_C:
                return (React.createElement(View, { style: [
                        styles.bottomBarContainerNoShadow,
                        isPositionAbsolute && {
                            position: 'absolute',
                            bottom: 0
                        },
                        isDarkMode && { backgroundColor: '#0D141F' }
                    ] },
                    btnLabel &&
                        React.createElement(Button, { id: id, typeDLS: btnTypeDLS, label: btnLabel, sizeDLS: btnSizeDLS, isDisabled: isDisabled, onPress: () => {
                                onPress &&
                                    onPress();
                            }, loading: _btnloading, action: action, triggerAction: triggerAction }),
                    label && (React.createElement(React.Fragment, null,
                        React.createElement(Space, { size: SizeTypeTokens.MD }),
                        React.createElement(Typography, { label: label, typeDLS: labelTypeDLS, color: labelColor ?
                                labelColor :
                                ColorTokens.Grey_Night, textAlign: TextAlignTokens.center }))),
                    children && (React.createElement(React.Fragment, null,
                        React.createElement(Space, { size: SizeTypeTokens.MD }),
                        children))));
            default:
                return (React.createElement(View, { style: [
                        styles.bottomBarContainerNoShadow,
                        isPositionAbsolute && {
                            position: 'absolute',
                            bottom: 0
                        }
                    ] },
                    label && (React.createElement(React.Fragment, null,
                        React.createElement(Typography, { label: label, typeDLS: labelTypeDLS, color: labelColor ?
                                labelColor :
                                ColorTokens.Grey_Night, textAlign: TextAlignTokens.center }),
                        React.createElement(Space, { size: SizeTypeTokens.MD }))),
                    children && (React.createElement(React.Fragment, null,
                        children,
                        React.createElement(Space, { size: SizeTypeTokens.MD }))),
                    btnLabel &&
                        React.createElement(Button, { id: id, typeDLS: btnTypeDLS, label: btnLabel, sizeDLS: btnSizeDLS, onPress: () => {
                                onPress &&
                                    onPress();
                            }, loading: _btnloading, action: action, triggerAction: triggerAction })));
        }
    };
    return (React.createElement(React.Fragment, null, child()));
};
const styles = StyleSheet.create({
    bottomBarContainerShadow: {
        width: '100%',
        justifyContent: 'center',
        borderColor: '#F2F4F7',
        borderTopWidth: 0.5,
        padding: 16,
        backgroundColor: 'white',
    },
    bottomBarContainerNoShadow: {
        width: '100%',
        justifyContent: 'center',
        padding: 16,
        backgroundColor: 'white',
    }
});
export default BottomBar;
